// Centralized API instance
import axios from 'axios';
import { Product } from 'types';

// Define the base URL and API Key based on environment
const baseURL =
    process.env.REACT_APP_API_BASE_URL || 'https://api.scorpioclassics.com/api';

const apiKey =
	process.env.REACT_APP_API_KEY ||
	'YourSuperSecretKey12345Whichsh0uldb3s3cur3a3p0ssible!'; // Add a default fallback for safety

const api = axios.create({
    baseURL,
});

// Add a request interceptor to attach the API key to all requests
api.interceptors.request.use((config) => {
    config.headers['X-API-KEY'] = apiKey;
    return config;
});

// Example endpoints refactored as reusable methods
export const fetchCategories = async () => {
	try {
		const response = await api.get('/categories');
		return response.data;
	} catch (error) {
		console.error('Error fetching categories:', error);
		throw error;
	}
};

export const fetchCategoryProducts = async (categoryName: string) => {
	try {
		const response = await api.get(`/categories/${categoryName}/products`);
		return response.data;
	} catch (error) {
		console.error('Error fetching category products:', error);
		throw error;
	}
};

export const fetchCategoryProductsByName = async (
	categoryName: string
): Promise<Product[]> => {
	try {
		const response = await api.get<Product[]>(
			`/categories/${categoryName}/products`
		);
		return response.data;
	} catch (error) {
		console.error('Error fetching category products by name:', error);
		throw error;
	}
};

export const fetchCategoryDetails = async (categoryName: string) => {
	try {
		const response = await api.get(`/categories/${categoryName}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching category details:', error);
		throw error;
	}
};

export const fetchProductDetails = async (productId: number) => {
	try {
		const response = await api.get(`/products/${productId}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching product details:', error);
		throw error;
	}
};

export const submitContactForm = async (contactData: {
	name: string;
	email: string;
	message: string;
	productId?: number;
}) => {
	try {
		const response = await api.post('/contact', contactData);
		return response.data;
	} catch (error) {
		console.error('Error submitting contact form:', error);
		throw error;
	}
};

export default api;
